module.exports = __webpack_public_path__ + "ae697bea9c9a3e75ad5a13e53b3692a4.png";